import React from "react";
import { Globe } from "lucide-react";

/* The editor's head: the policy's number (a globe for Everyone else), a kicker saying where
   it stands, its name, and its controls on the right. */
export function EditorHeader({ n, kicker, children, actions }: {
  n: number | null;
  kicker: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <div className="flex items-center gap-2.5 min-w-0 mb-7">
      <span className="w-7 h-7 shrink-0 rounded-[8px] bg-[var(--surface-2)] flex items-center justify-center font-mono tabular-nums text-[12px] text-[var(--text-secondary)]">
        {n === null ? <Globe className="w-[14px] h-[14px]" strokeWidth={1.75} /> : n}
      </span>
      <div className="min-w-0 flex-1">
        <div className="truncate text-[11.5px] text-[var(--text-tertiary)]">{kicker}</div>
        {children}
      </div>
      {actions}
    </div>
  );
}
